import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgLoaderComponent } from '../../images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-star-rating',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss'
})
export class StarRatingComponent {
  @Input() rating: number = 0;
  @Output() ratingChange = new EventEmitter<number>();

  setRating(val: number) {
    this.rating = val;
    this.ratingChange.emit(val);
  }

  onStarClick(event: MouseEvent, val: number) {
    event.stopPropagation();
    this.setRating(val);
  }
}
